import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useClickOutsideElement } from '../../services/hooks/useClickOutsideElement.js';
import Badge from '../Badge/Badge.js';
import Icon from '../Icon/Icon.js';
import PopOver from '../PopOver/PopOver.js';
import styles from './TopElement.module.scss.js';

var TopElement = function TopElement(_ref) {
  var title = _ref.title,
    desc = _ref.desc,
    position = _ref.position,
    popoverTxt = _ref.popoverTxt;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    t1 = _useState2[0],
    setT1 = _useState2[1];
  var popOver = useRef(null);
  var closePreview = function closePreview() {
    setT1(false);
  };
  useClickOutsideElement(popOver, closePreview);
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    popContent = _useState4[0],
    setPopContent = _useState4[1];
  var showPop = function showPop(txt) {
    setPopContent(txt);
    setT1(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(PopOver, {
    passRef: popOver,
    className: styles.popover,
    visible: t1
  }, /*#__PURE__*/React.createElement("p", null, popContent)), /*#__PURE__*/React.createElement("div", {
    className: styles.fixed
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.number
  }, /*#__PURE__*/React.createElement(Badge, {
    className: styles.black,
    count: position
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, desc))), /*#__PURE__*/React.createElement("div", {
    className: styles.rightGroup
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-info",
    onClick: function onClick() {
      return showPop(popoverTxt);
    }
  })));
};
TopElement.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  position: PropTypes.number.isRequired,
  popoverTxt: PropTypes.string.isRequired
};
TopElement.defaultProps = {
  desc: ''
};

export { TopElement as default };
